import { InputBase, Select, SelectProps, styled } from '@material-ui/core';

const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: 120,
  fontSize: theme.typography.body2.fontSize,
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
  '& svg:last-child': {
    right: 6,
  },
}));

const StyledInput = styled(InputBase)({
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  height: 32,
  padding: 'var(--encore-spacing-tighter-5) var(--encore-spacing-tighter-4)',
});

export const ToolbarSelect = (props: SelectProps) => (
  <StyledSelect input={<StyledInput />} {...props} />
);
